import { PositionType } from 'data/types';
import {
  AREA_BASELINE_OFFSET,
  AREA_LABEL_FONT_SIZE,
  DIMENSIONS_LABEL_FONT_SIZE,
  DIMENSIONS_LINE_OFFSET
} from 'utils/footprint-area-label-layout';

type FootprintAreaLabelProps = Readonly<{
  anchor: PositionType;
  areaLabel: string;
  dimensionsLabel: string | null;
}>;

export default function FootprintAreaLabel({
  anchor,
  areaLabel,
  dimensionsLabel
}: FootprintAreaLabelProps) {
  const areaBaseline = anchor.y - AREA_BASELINE_OFFSET;

  return (
    <>
      <text
        x={anchor.x}
        y={areaBaseline}
        textAnchor='middle'
        fontSize={AREA_LABEL_FONT_SIZE}
        fontWeight='600'
        fill='#000000'
        style={{ pointerEvents: 'none', userSelect: 'none' }}
      >
        {areaLabel}
      </text>
      {dimensionsLabel && (
        <text
          x={anchor.x}
          y={areaBaseline + DIMENSIONS_LINE_OFFSET}
          textAnchor='middle'
          fontSize={DIMENSIONS_LABEL_FONT_SIZE}
          fontWeight='500'
          fill='#4b5563'
          style={{ pointerEvents: 'none', userSelect: 'none' }}
        >
          {dimensionsLabel}
        </text>
      )}
    </>
  );
}
